module.exports = __webpack_public_path__ + "static/media/1_A1_04.637f1cb2.png";